import { render, staticRenderFns } from "./LogoUpload.vue?vue&type=template&id=1645284f&"
import script from "./LogoUpload.vue?vue&type=script&lang=js&"
export * from "./LogoUpload.vue?vue&type=script&lang=js&"
import style0 from "./LogoUpload.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports